import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import groupButton from '@/components/button/group'
import { serviceNameKebabCase } from '@/components/services/report-manager/queue/utils'
import sticker from '@/components/sticker'

function renderActivator(h) {
  return h(
    sticker,
    {
      props: this.activatorProps,
      slot: 'activator'
    }
  )
}
function renderPresetButtons(h) {
  return h(
    groupButton,
    {
      props: {
        value: this.preset,
        items: this.presetButtons,
        fullWidth: true,
        equalWidth: true
      },
      on: {
        input: event => {
          this.preset = event
        }
      }
    }
  )
}
function renderHeaders(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.headers,
        label: this.getTranslate(`${Services['report-manager']}.labels.encodingSettings.headers`),
        outline: true
      },
      on: {
        input: event => {
          this.proxy.headers = event
        }
      }
    }
  )
}
function renderFields(h) {
  return Object.keys(this.encodingSettings).map(setting => {
    return h(
      components.select,
      {
        props: {
          value: this.proxy[setting],
          label: this.getTranslate(`${Services['report-manager']}.labels.encodingSettings.${setting}`),
          items: this.encodingSettings[setting].items,
          details: false,
          dense: true
        },
        on: {
          input: event => {
            this.proxy[setting] = event
          }
        }
      }
    )
  })
}
function renderContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-menu ${serviceNameKebabCase}-menu--encoding`
    },
    [
      renderPresetButtons.call(this, h),
      renderFields.call(this, h),
      renderHeaders.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderActivator.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
